const idCounter = {};

const uniqueId = (prefix = "$default$") => {
    if (!idCounter[prefix]) {
        idCounter[prefix] = 0;
    }

    const id = ++idCounter[prefix];

    if (prefix === "$default$") {
        return `${id}`;
    }

    return `${prefix}${id}`;
};

export default uniqueId;